module.exports = __webpack_public_path__ + "img/logo_large.5ad61e72.png";